import React from 'react';
import { Translation } from 'react-i18next';
import { get, set, camelCase } from 'lodash';

export const generateErrorsForRequiredFields = (requiredFields, values, errors) => {
  requiredFields.forEach(field => {
    if (typeof field === 'object') {
      const fieldValue = get(values, field.fieldKey);
      if (!fieldValue || (fieldValue.trim && !fieldValue.trim())) {
        set(
          errors,
          field.fieldKey,
          <Translation>{t => t(`${camelCase(field.key)}EmptyErr`)}</Translation>
        );
      }
    } else {
      const fieldValue = get(values, field);
      if (!fieldValue || (fieldValue.trim && !fieldValue.trim())) {
        set(errors, field, <Translation>{t => t(`${camelCase(field)}EmptyErr`)}</Translation>);
      }
    }
  });
  return errors;
};
